// ========== frontend/src/App.jsx ==========
import React, { useState, useEffect } from 'react';
import LiveGeofenceDashboard from './LiveGeofenceDashboard';
import GeofenceExceedances from './GeofenceExceedances';
import InternalGeofenceDashboard from './InternalGeofenceDashboard';
import AccessGate from './AccessGate';

import './styles.css';

export default function App() {
  const [activeTab, setActiveTab] = useState('live');
  const [user, setUser] = useState(null); // Estado para el usuario

  /* 
    OJO aquí estoy simulando el login.
    La idea es que el usuario se loguee desde el login EBTapps
  */
  useEffect(() => {

    const loggedInUser = localStorage.getItem('user');
    if (loggedInUser) {
      setUser(JSON.parse(loggedInUser));
    } else {
      // Ejemplo de usuario (remover en producción)
      const exampleUser = { id: 1, name: 'Usuario Demo', email: 'user@ebtlogistics.com' };
      setUser(exampleUser);
      localStorage.setItem('user', JSON.stringify(exampleUser));
    }
  }, []);

  return (
    <div className="app-container">
      <div className="nav-tabs">
        <button 
          className={`nav-tab-button ${activeTab === 'live' ? 'active' : ''}`}
          onClick={() => setActiveTab('live')}
        >
          Monitoreo en Tiempo Real
        </button>
        <button 
          className={`nav-tab-button ${activeTab === 'internal' ? 'active' : ''}`}
          onClick={() => setActiveTab('internal')}
        >
          Nuestras Terminales
        </button>
        <button 
          className={`nav-tab-button ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          Historial de Excedencias
        </button>
      </div>
      
      <div className="user-info">
        {user && <span>Usuario: {user.name}</span>}
      </div>
      
      <div className="tab-content">
        {activeTab === 'live' && 
          <AccessGate>
            <LiveGeofenceDashboard key="live" user={user} />
          </AccessGate>
        }
        {activeTab === 'internal' && 
        <AccessGate>
          <InternalGeofenceDashboard key="internal" user={user} />
        </AccessGate>}
        {activeTab === 'history' && 
          <AccessGate>
            <GeofenceExceedances key="history" user={user} />
          </AccessGate>
        }
      </div>
    </div>
  );
}